module.exports = __webpack_public_path__ + "img/15.fe1ff6f6.png";